import { IsoFields, ZonedDateTime, ZoneId } from "@js-joda/core";
import { I, T } from "services/lang/LanguageService";
import { DayTypes, MonthDisplayType, MonthTypes, Position, YearTypes } from "./CurentDateDisplayTypes";
import { getLastFinishedWeek, monthsArray, monthsArrayShort } from "../charts/utils";

const getCurrentDate = (
  timezone: ZoneId,
  displayWeekOfYear?: boolean,
  showFinishedWeek?: boolean,
  year?: YearTypes,
  month?: MonthTypes,
  day?: DayTypes,
) => {
  const refZdt = ZonedDateTime.now(timezone);
  if (displayWeekOfYear) {
    let weekOfYear = refZdt.get(IsoFields.WEEK_OF_WEEK_BASED_YEAR);
    if (showFinishedWeek) {
      weekOfYear = getLastFinishedWeek(weekOfYear, refZdt.year(), refZdt).refWeek;
    }
    return `${T("word.week")} ${weekOfYear}`;
  }

  const currentYear = refZdt.year();
  let monthNumber = refZdt.monthValue();
  const currentDay = refZdt.dayOfMonth();

  const parts: { value: string; position: Position }[] = [];

  if (year?.show ?? true) {
    parts.push({
      value: `${currentYear}${year?.suffix ? ` ${I(year.suffix)}` : ""}`,
      position: year?.position ?? Position.START,
    });
  }

  if (month?.show ?? true) {
    if (month?.showFinishedMonth) {
      monthNumber -= 1;
      if (monthNumber < 1) {
        monthNumber = 12;
      }
    }

    let monthStr: string;
    switch (month?.displayType) {
      case MonthDisplayType.STRING_LONG:
        monthStr = monthsArray[monthNumber - 1];
        break;
      case MonthDisplayType.STRING_SHORT:
        monthStr = monthsArrayShort[monthNumber - 1];
        break;
      default:
        monthStr = monthNumber.toString();
    }
    parts.push({
      value: monthStr,
      position: month?.position ?? Position.MIDDLE,
    });
  }

  if (day?.show ?? true) {
    parts.push({
      value: `${currentDay}`,
      position: day?.position ?? Position.END,
    });
  }

  const ordered = [Position.START, Position.MIDDLE, Position.END].flatMap(pos => parts.filter(p => p.position === pos));

  return ordered.map(p => p.value).join(" ");
};

export default getCurrentDate;
